module.exports = __webpack_public_path__ + "static/media/right-arrow-table.d51a86ad.svg";